import React from 'react'
import { createRoot } from 'react-dom/client'

// sort-imports-ignore
import './stylesheets/style.scss'
import './app/globals.css'
import 'react-toastify/dist/ReactToastify.min.css'
import { RenderType, type StoreType, createCoreStore, IAppDispatch } from './store/store.ts'
import App from './App'
import { Provider } from 'react-redux'
import { coreReducer } from '@/store/coreReducer.ts'
import { LocalStorage } from '@/store/storage/LocalStorage.ts'
import { subscriptionMiddleware } from '@/store/storage/subscriptionMiddleware.ts'
import { persistedObserver } from '@/store/observers/persistedObserver.ts'
import { Middleware } from '@reduxjs/toolkit'
import { createLogger } from 'redux-logger'
const middlewares: any[] = []

if (import.meta.env.MODE === 'development') {
	const reduxLogger = createLogger({
		collapsed: true,
		duration: true,
		level: {
			prevState: false,
			action: 'info',
			nextState: 'info',
		},
	})
	middlewares.push(reduxLogger as Middleware<object, any, IAppDispatch>)
}

const localStorage = new LocalStorage({
	name: 'telstra:phoenix',
	storeName: 'phoenix:state',
	items: [],
})

middlewares.push(subscriptionMiddleware(localStorage))

// middlewares.push(authApi.middleware)

const render = (store: StoreType) => {
	const element = document.getElementById('root')
	if (element !== null) {
		const root = createRoot(element)
		root.render(
			<React.StrictMode>
				<Provider store={store}>
					<App />
				</Provider>
			</React.StrictMode>,
		)
	}
}

createCoreStore(
	coreReducer,
	middlewares,
	localStorage,
	localStorage.getItems(),
	6,
	[
		(store: StoreType) => {
			return persistedObserver(store)
		},
	],
	(_: StoreType): Promise<any>[] => {
		//createObservers(store).then(() => {}
		return []
	},
	store => {
		render(store)
	},
	RenderType.EARLY,
)
